import React from "react";
import { HiCheck } from "react-icons/hi";

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  stepTitles: string[];
}

export const StepIndicator: React.FC<StepIndicatorProps> = ({
  currentStep,
  totalSteps,
  stepTitles
}) => {

  const getStepStatus = (stepNumber: number) => {
    if (stepNumber < currentStep) {
      return "completed";
    } else if (stepNumber === currentStep) {
      return "current";
    } else {
      return "upcoming";
    }
  };

  const getStepStyles = (status: string) => {
    switch (status) {
      case "completed":
        return "bg-success text-white border-success";
      case "current":
        return "bg-brand text-white border-brand";
      case "upcoming":
        return "bg-gray-100 text-muted border-gray-200 dark:bg-gray-700 dark:text-gray-500 dark:border-gray-600";
      default:
        return "bg-gray-100 text-muted border-gray-200 dark:bg-gray-700 dark:text-gray-500 dark:border-gray-600";
    }
  };

  return (
    <div className="flex items-center justify-center space-x-8 mb-6">
      {Array.from({ length: totalSteps }, (_, index) => {
        const stepNumber = index + 1;
        const status = getStepStatus(stepNumber);
        const isLast = stepNumber === totalSteps;

        return (
          <div key={stepNumber} className="flex items-center">
            {/* Step Circle */}
            <div className="flex items-center space-x-3">
              <div
                className={`
                  w-8 h-8 rounded-full border-2 flex items-center justify-center
                  transition-all duration-200 ease-in-out
                  ${getStepStyles(status)}
                `}
              >
                {status === "completed" ? (
                  <HiCheck className="w-4 h-4" />
                ) : (
                  <span className="text-sm font-medium">{stepNumber}</span>
                )}
              </div>
              
              {/* Step Label */}
              <span className={`text-sm font-medium ${
                status === "current"
                  ? "text-brand dark:text-lgb-blue-200"
                  : status === "completed"
                  ? "text-success dark:text-lgb-green-200"
                  : "text-muted"
              }`}>
                {stepTitles[index]}
              </span>
            </div>

            {/* Connector Arrow */}
            {!isLast && (
              <div className="mx-4">
                <svg 
                  className={`w-4 h-4 ${
                    stepNumber < currentStep 
                      ? "text-success" 
                      : "text-gray-300 dark:text-gray-600"
                  }`} 
                  fill="currentColor" 
                  viewBox="0 0 20 20"
                >
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}; 